import { store } from "@redux"
import onlyPositiveNumber from "./onlyPositiveNumber"
import ObjectValues from "./ObjectValues"

const isTaxAppliable = (taxItem, deliveryType, item) => {
  if (item.taxInclusive) return false

  const onlyThisDeliveries =
    taxItem.onlyThisDeliveries || []

  return onlyThisDeliveries.includes(deliveryType)
}

const getDeliveryFee = (fee, discounts, deliveryType) => {
  if (deliveryType !== "delivery") return 0

  if (fee === 0) return 0

  if (discounts.length > 0) {
    const totalDelivertyDiscount =
      discounts.reduce((t, d) =>
        t += d.deliveryDiscount
        , 0
      )

    const result = fee - totalDelivertyDiscount

    return result >= 0 ? result : 0
  }

  return fee
}

const calculateOrderItemsTaxes = (
  orderItems,
  deliveryFees,
  discounts,
  deliveryType
) => {
  const result = {}

  const {
    systemSettings: { taxOnDelivery }
  } = store.getState()

  const totalOrderPrice =
    orderItems.reduce((to, orderItem) => (
      to +=
      (orderItem.salePrice - orderItem.systemDiscount) * orderItem.quantity
    ), 0)

  const fee = Number(deliveryFees?.fee || 0)

  const deliveryFee =
    getDeliveryFee(fee, discounts, deliveryType)

  orderItems.forEach((orderItem, iIndex) => {
    const itemDiscount =
      discounts.reduce((t, d) =>
        t += (d.items[iIndex]?.foodDiscount || 0)
        , 0
      )

    const totalOrderItemSpecificationItems =
      orderItem.specificationItems.reduce((t, si) =>
        t += si.salePrice * (si.quantity - si.freeQuantity)
        , 0
      )

    const orderItemSalePrice =
      orderItem.salePrice +
      totalOrderItemSpecificationItems -
      orderItem.systemDiscount

    const itemSalePriceWithDiscount =
      onlyPositiveNumber(
        orderItemSalePrice *
        orderItem.quantity -
        itemDiscount
      )

    const weight =
      orderItemSalePrice *
      orderItem.quantity /
      totalOrderPrice

    const itemDeliveryFee = deliveryFee * weight

    orderItem.taxItems.forEach(taxItem => {
      const taxAppliable =
        isTaxAppliable(
          taxItem,
          deliveryType,
          orderItem
        )

      if (!taxAppliable) return

      const percentage = taxItem.percent / 100

      if (!!result[taxItem.title]) {
        result[taxItem.title] = {
          title: taxItem.title,
          titleEn: taxItem.titleEn,
          titleAr: taxItem.titleAr,
          isNotTax: taxItem.isNotTax,
          percentage: taxItem.percent,
          constantValue: taxItem.constantValue,
          isPercentageModel: taxItem.isPercentageModel,
          amount:
            taxItem.isPercentageModel
              ?
              result[taxItem.title].amount +
              itemSalePriceWithDiscount * percentage
              :
              result[taxItem.title].amount +
              orderItem.quantity * taxItem.constantValue
        }

        if (taxOnDelivery) {
          result[taxItem.title] = {
            title: taxItem.title,
            titleEn: taxItem.titleEn,
            titleAr: taxItem.titleAr,
            percentage: taxItem.percent,
            constantValue: taxItem.constantValue,
            isNotTax: taxItem.isNotTax,
            isPercentageModel: taxItem.isPercentageModel,
            amount:
              taxItem.isPercentageModel
                ?
                result[taxItem.title].amount +
                itemDeliveryFee * percentage
                :
                result[taxItem.title].amount +
                orderItem.quantity * taxItem.constantValue
          }
        }

        return
      }

      result[taxItem.title] = {
        title: taxItem.title,
        titleEn: taxItem.titleEn,
        titleAr: taxItem.titleAr,
        percentage: taxItem.percent,
        constantValue: taxItem.constantValue,
        isNotTax: taxItem.isNotTax,
        isPercentageModel: taxItem.isPercentageModel,
        amount:
          taxItem.isPercentageModel
            ? itemSalePriceWithDiscount * percentage
            : orderItem.quantity * taxItem.constantValue
      }

      if (taxOnDelivery) {
        result[taxItem.title] = {
          title: taxItem.title,
          titleEn: taxItem.titleEn,
          titleAr: taxItem.titleAr,
          percentage: taxItem.percent,
          constantValue: taxItem.constantValue,
          isNotTax: taxItem.isNotTax,
          isPercentageModel: taxItem.isPercentageModel,
          amount:
            taxItem.isPercentageModel
              ?
              result[taxItem.title].amount +
              itemDeliveryFee * percentage
              :
              result[taxItem.title].amount +
              orderItem.quantity * taxItem.constantValue
        }
      }
    })
  })

  return result
}

const calculateComboTaxes = (
  combos,
  deliveryFees,
  deliveryType
) => {
  const result = {}

  const {
    systemSettings: { taxOnDelivery }
  } = store.getState()

  combos.forEach(combo => {
    const totalComboPrice =
      combo.items.reduce((to, comboItem) =>
        to +=
        comboItem.salePrice *
        comboItem.quantity
        , 0
      )

    combo.items.forEach(comboItem => {
      const weight =
        comboItem.salePrice *
        comboItem.quantity /
        totalComboPrice

      const itemDiscount =
        combo.comboDiscount * weight

      const itemSalePriceWithDiscount =
        onlyPositiveNumber(
          comboItem.salePrice *
          comboItem.quantity -
          itemDiscount
        )

      const deliveryFee =
        deliveryType === "delivery" ?
          Number(deliveryFees?.fee || 0) : 0

      const itemDeliveryFee = deliveryFee * weight

      comboItem.taxItems.forEach(taxItem => {
        const taxAppliable =
          isTaxAppliable(
            taxItem,
            deliveryType,
            comboItem
          )

        if (!taxAppliable) return

        const percentage = taxItem.percent / 100

        if (!!result[taxItem.title]) {
          result[taxItem.title] = {
            title: taxItem.title,
            titleEn: taxItem.titleEn,
            titleAr: taxItem.titleAr,
            percentage: taxItem.percent,
            constantValue: taxItem.constantValue,
            isNotTax: taxItem.isNotTax,
            isPercentageModel: taxItem.isPercentageModel,
            amount:
              taxItem.isPercentageModel
                ?
                result[taxItem.title].amount +
                itemSalePriceWithDiscount * percentage
                :
                result[taxItem.title].amount +
                comboItem.quantity * taxItem.constantValue
          }

          if (taxOnDelivery) {
            result[taxItem.title] = {
              title: taxItem.title,
              titleEn: taxItem.titleEn,
              titleAr: taxItem.titleAr,
              percentage: taxItem.percent,
              constantValue: taxItem.constantValue,
              isNotTax: taxItem.isNotTax,
              isPercentageModel: taxItem.isPercentageModel,
              amount:
                taxItem.isPercentageModel
                  ?
                  result[taxItem.title].amount +
                  itemDeliveryFee * percentage
                  :
                  result[taxItem.title].amount +
                  comboItem.quantity * taxItem.constantValue
            }
          }

          return
        }

        result[taxItem.title] = {
          title: taxItem.title,
          titleEn: taxItem.titleEn,
          titleAr: taxItem.titleAr,
          percentage: taxItem.percent,
          constantValue: taxItem.constantValue,
          isNotTax: taxItem.isNotTax,
          isPercentageModel: taxItem.isPercentageModel,
          amount:
            taxItem.isPercentageModel
              ? itemSalePriceWithDiscount * percentage
              : comboItem.quantity * taxItem.constantValue
        }

        if (taxOnDelivery) {
          result[taxItem.title] = {
            title: taxItem.title,
            titleEn: taxItem.titleEn,
            titleAr: taxItem.titleAr,
            percentage: taxItem.percent,
            constantValue: taxItem.constantValue,
            isNotTax: taxItem.isNotTax,
            isPercentageModel: taxItem.isPercentageModel,
            amount:
              taxItem.isPercentageModel
                ?
                result[taxItem.title].amount +
                itemDeliveryFee * percentage
                :
                result[taxItem.title].amount +
                comboItem.quantity * taxItem.constantValue
          }
        }
      })
    })
  })

  return result
}

const sumOfTaxes = (comboTaxes, orderItemsTaxes) => {
  const isComboTaxesEmpty =
    Object.keys(comboTaxes).length === 0

  if (isComboTaxesEmpty)
    return ObjectValues(orderItemsTaxes)

  const isOrderItemsTaxesEmpty =
    Object.keys(orderItemsTaxes).length === 0

  if (isOrderItemsTaxesEmpty)
    return ObjectValues(comboTaxes)

  const result = {
    ...orderItemsTaxes,
    ...comboTaxes
  }

  Object.keys(orderItemsTaxes).forEach(taxName => {
    result[taxName] = {
      ...result[taxName],
      amount:
        result[taxName].amount +
        orderItemsTaxes[taxName].amount
    }
  })

  return ObjectValues(result)
}

const calculateTaxesAndCharges = (
  combos,
  orderItems,
  deliveryFees,
  discounts,
  deliveryType
) => {
  const comboTaxes =
    calculateComboTaxes(
      combos,
      deliveryFees,
      deliveryType
    )

  const orderItemsTaxes =
    calculateOrderItemsTaxes(
      orderItems,
      deliveryFees,
      discounts,
      deliveryType
    )

  const result =
    sumOfTaxes(comboTaxes, orderItemsTaxes)

  return result
}

export default calculateTaxesAndCharges